<template> 
  <div style="display: none;"> 
    <slot v-if="ready"></slot> 
  </div> 
</template> 
 
<script> 
import 'leaflet.markercluster' 
import { findRealParent, propsBinder, L } from 'vue2-leaflet' 
const props = { 
  options: { 
    type: Object, 
    default() { return {}; }, 
  }, 
}; 
export default { 
  props, 
  data() { 
    return { 
      ready: false, 
    }; 
  }, 
  mounted() { 
    this.mapObject = L.markerClusterGroup(this.options); 
    L.DomEvent.on(this.mapObject, this.$listeners); 
    propsBinder(this, this.mapObject, props); 
    this.ready = true; 
    this.parentContainer = findRealParent(this.$parent); 
    this.parentContainer.addLayer(this); 
  }, 
  beforeDestroy() { 
    this.parentContainer.removeLayer(this); 
  }, 
  methods: { 
    addLayer(layer, alreadyAdded) { 
      if (!alreadyAdded) { 
        this.mapObject.addLayer(layer.mapObject); 
      } 
    }, 
    removeLayer(layer, alreadyRemoved) { 
      if (!alreadyRemoved) { 
        this.mapObject.removeLayer(layer.mapObject); 
      } 
    }, 
  }, 
}; 
</script>